import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大内容板块，满足您的多样化在线观看需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-white rounded-xl group-hover:bg-primary-500 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </div>
              <span className="font-heading text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 text-center leading-relaxed hidden sm:block">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}